import { render, staticRenderFns } from "./Dashbord.vue?vue&type=template&id=51513981&scoped=true&"
import script from "./Dashbord.vue?vue&type=script&lang=js&"
export * from "./Dashbord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51513981",
  null
  
)

export default component.exports